import React from 'react';
import useRentals from "../../hooks/useRentals";
import Loading from "../shared/wait/Loading";
import ModelBookingsPie from "./stats/ModelBookingsPie";
import RentalBookingsBar from "./stats/RentalBookingsBar";
import NumBookingsLine from "./stats/NumBookingsLine";

const Estadistics = () => {
  const {
    rentals,
    isLoading: isLoadingRentals
  } = useRentals({
    populateBookings: true
  })


  if (isLoadingRentals) return <Loading/>

  return (
    <div className="container-fluid py-4">
      <div className="row">
        <div className="col-12">
          <NumBookingsLine rentals={rentals}/>
        </div>
        <div className="col-12 col-md-6">
          <ModelBookingsPie rentals={rentals}/>
        </div>
        <div className="col-12 col-md-6">
          <RentalBookingsBar rentals={rentals}/>
        </div>
      </div>
    </div>
  );
}

export default Estadistics;
